<script lang="ts" setup>
import { SmrLoadingErrorReason } from '@/store/modules/stay/smr/types'

defineProps<{
  stayId: string
  idType: string
  reason: SmrLoadingErrorReason | null
}>()

</script>

<template>
  <div
    v-if="reason"
    class="stay-page-error-message col-auto mx-auto"
  >
    <div
      v-if="reason === SmrLoadingErrorReason.SMR_STAY_NOT_FOUND"
    >
      <h1>Le séjour SMR ({{ idType }} : {{ stayId }}) n'a pas pu être trouvé.</h1>
      <div>Cette erreur peut être provoquée par les causes suivantes :</div>
      <ul>
        <li>L'identifiant fourni est erroné ou n'existe pas.</li>
        <li>Le séjour n'a pas encore été importé par Sancare (probable si le séjour est récent).</li>
      </ul>
    </div>
    <div v-else>
      <h1>Une erreur est survenue...</h1>
      <div>Le séjour SMR ({{ idType }} : {{ stayId }}) ne peut pas être affiché, car une erreur est survenue lors de son chargement.</div>
      <div>Si le problème se répète, n'hésitez pas à envoyer un rapport de bug à Sancare (icône en haut à droite de l'écran).</div>
    </div>
  </div>
</template>
